import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import ReceivableFinancing2PageUI from './ReceivableFinancing2PageUI.js'

class ReceivableFinancing2PageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      receivableFinancingList: null,
    }
  }

  render() {
    return (
      <ReceivableFinancing2PageUI
        context={this.props.context}
        account={this.state.account}
        receivableFinancingList={this.state.receivableFinancingList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getReceivableFinancing(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getReceivableFinancing(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/loans/receivableFinancing`,
      cacheKey: CacheKeys.ReceivableFinancing(this.props.match.params.accountId),
      callback: this.getReceivableFinancingCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getReceivableFinancingCallback = (response) => {
    this.setState({ errorList: response.errorList, receivableFinancingList: response.receivableFinancingList })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Accounts(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.ReceivableFinancing(this.props.match.params.accountId))
    if (noBusy === 'noBusy') {
      this.getAccounts(context)
      this.getReceivableFinancing(context)
    }
    else
      this.setState({ account: null, receivableFinancingList: null }, () => {
        this.getAccounts(context)
        this.getReceivableFinancing(context)
      })
  }
}

export default withRouter(ReceivableFinancing2PageSF)
